import { DatasCronograma } from "../types";

export const calcularDatas = (dataTermino: string): DatasCronograma => {
  console.log("📅 Calculando datas para término do mandato:", dataTermino);
  const termino = new Date(dataTermino);
  console.log("📅 Data de término convertida:", termino.toISOString());

  const datas: DatasCronograma = {
    // 1. Formação da Comissão Eleitoral - 60 dias antes (mínimo exigido pela NR-05)
    formacaoComissao: new Date(termino.getTime() - 60 * 24 * 60 * 60 * 1000),

    // 2. Comunicação ao Sindicato - 58 dias antes (após formação da comissão)
    comunicacaoSindicato: new Date(
      termino.getTime() - 58 * 24 * 60 * 60 * 1000,
    ),

    // 3. Publicação do Edital - 45 dias antes (mínimo para abrir inscrições)
    edital: new Date(termino.getTime() - 45 * 24 * 60 * 60 * 1000),

    // 4. Início das Inscrições - 44 dias antes (1 dia após edital)
    inicioInscricoes: new Date(termino.getTime() - 44 * 24 * 60 * 60 * 1000),

    // 5. Término das Inscrições - 29 dias antes (15 dias de prazo mínimo)
    terminoInscricoes: new Date(termino.getTime() - 29 * 24 * 60 * 60 * 1000),

    // 6. Publicação da Lista de Candidatos - 28 dias antes (1 dia após término das inscrições)
    publicacaoLista: new Date(termino.getTime() - 28 * 24 * 60 * 60 * 1000),

    // 7. Eleição - 31 dias antes (mínimo exigido pela NR-05)
    eleicao: new Date(termino.getTime() - 31 * 24 * 60 * 60 * 1000),

    // 8. Apuração - 30 dias antes (1 dia após eleição)
    apuracao: new Date(termino.getTime() - 30 * 24 * 60 * 60 * 1000),

    // 9. Treinamento - 15 dias antes (antes da posse)
    inicioTreinamento: new Date(termino.getTime() - 15 * 24 * 60 * 60 * 1000),

    // 10. Posse - 1 dia após término do mandato
    posse: new Date(termino.getTime() + 1 * 24 * 60 * 60 * 1000),
  };

  console.log("📅 Datas calculadas:");
  console.log(
    "  - Formação Comissão:",
    datas.formacaoComissao.toISOString().split("T")[0],
  );
  console.log(
    "  - Comunicação Sindicato:",
    datas.comunicacaoSindicato.toISOString().split("T")[0],
  );
  console.log("  - Edital:", datas.edital.toISOString().split("T")[0]);
  console.log(
    "  - Início Inscrições:",
    datas.inicioInscricoes.toISOString().split("T")[0],
  );
  console.log(
    "  - Término Inscrições:",
    datas.terminoInscricoes.toISOString().split("T")[0],
  );
  console.log(
    "  - Publicação Lista:",
    datas.publicacaoLista.toISOString().split("T")[0],
  );
  console.log("  - Eleição:", datas.eleicao.toISOString().split("T")[0]);
  console.log("  - Apuração:", datas.apuracao.toISOString().split("T")[0]);
  console.log(
    "  - Treinamento:",
    datas.inicioTreinamento.toISOString().split("T")[0],
  );
  console.log("  - Posse:", datas.posse.toISOString().split("T")[0]);

  return datas;
};

export const formatarData = (data: Date | string): string => {
  const dateObj = typeof data === "string" ? new Date(data) : data;
  return dateObj.toLocaleDateString("pt-BR", {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatarDataSimples = (data: Date | string): string => {
  const dateObj = typeof data === "string" ? new Date(data) : data;
  return dateObj.toLocaleDateString("pt-BR");
};

export const getStatusColor = (data: Date | string): string => {
  const dateObj = typeof data === "string" ? new Date(data) : data;
  const hoje = new Date();
  const diasRestantes = Math.ceil(
    (dateObj.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24),
  );

  if (diasRestantes < 0) return "text-red-600";
  if (diasRestantes <= 7) return "text-orange-600";
  if (diasRestantes <= 30) return "text-yellow-600";
  return "text-green-600";
};

export const calcularDiasRestantes = (data: Date | string): number => {
  const dateObj = typeof data === "string" ? new Date(data) : data;
  const hoje = new Date();
  return Math.ceil(
    (dateObj.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24),
  );
};
